import { useState, useEffect, useRef } from 'react';
import '../../../App.css';
import AutocompletePaginado from '../../AutocompletePaginado';
import Table from '../../Table';
import {useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { handleErrors, request } from '../../../utils/ApiUtils';
import CollapsibleFilters from '../../CollapsibleFilters';
import { getStatusBadgeStyle } from '../../../utils/StatusStyleUtils';
import { LuReceipt } from 'react-icons/lu';

function Despesas() {
    const [centroCusto, setCentroCusto] = useState({})
    const [categoria, setCategoria] = useState({})

    const navigate = useNavigate();
    const [pageData, setPageData] = useState([]);
    const [dataArray, setDataArray] = useState([]);
    const firstRender = useRef(0);
    const [fetchListError, setFetchListError] = useState();

    const [loading, setLoading] = useState(true);

    const carregarDados = async (page = 0) => {
        request(`despesas/paginated?page=${page}`, {
            type: 'POST',
            body: JSON.stringify({
                centroCusto: centroCusto?.id ? centroCusto : null,
                categoria: categoria?.id ? categoria : null
            }),
            callback: (data) => (
                setPageData(data),
                setDataArray(data.content)
            ),
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao buscar despesas: '+message, {setFetchListError}) },
            finally: () => setLoading({loading: false})
        })
    };

    useEffect(() => {
        carregarDados();
    }, []);

    useEffect(() => {
        if (firstRender.current < 1) {
            firstRender.current = firstRender.current+1;
            return;
        }
        carregarDados();
    }, [centroCusto, categoria]);

    const tableParams = {
        query: (page) => carregarDados(page),
        columns: [
            {
                label: "Centro de Custo",
                width: "20%",
                type: "input",
                key: "centroCusto.nome",
                disabled: true,
                getValue: (item) => (item.centroCusto?.nome || '')
            },
            {
                label: "Categoria",
                width: "20%",
                type: "input",
                key: "categoria.nome",
                disabled: true,
                getValue: (item) => (item.categoria?.nome || '')
            },
            {
                label: "Data",
                width: "12%",
                type: "date",
                disabled: true,
                key: "dataVencimento"
            },
            {
                label: "Valor",
                width: "12%",
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "valor"
            },
            {
                label: "Status",
                width: "12%",
                type: "autocomplete",
                css: "status-badge",
                component: {
                    endpoint: "despesas/status",
                    parameters: {
                        disabled: true,
                        width: '100%',
                        bodyToSearch: { statusContrato: true },
                        getLabel: (despesa) => despesa.status || '',
                        getValue: (despesa) => despesa.status,
                        inputStyle: (status) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                        POST: true,
                        reload: !!loading?.loading
                    },
                }
            },
            {
                label: "Editar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                onClick: (despesa) => navigate(`/despesas/cadastro/${despesa.id}`)
            }
        ]
    };

    return (
        <div className="form-container list-page">
            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>
            <div className="header-container">
                <div className="page-title-content">
                    <LuReceipt aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Despesas</h1>
                </div>
                <Button className="new-contract-button" variant="contained" onClick={() => navigate(`/despesas/cadastro`)}>
                    Nova despesa
                </Button>
            </div>

            <CollapsibleFilters>
            <div className='row'>
                <AutocompletePaginado label={"Centro de Custo"}
                    parameters={{
                        width: '25%',
                        label: "Centro de Custo",
                        disabled: false,
                        bodyToSearch: { somenteAtivos: true, centroCusto: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => setCentroCusto(itemSelecionado?.item),
                        bodyToSearch: { centroCusto: true, somenteAtivos: true }
                    }}
                    endpoint={"configdespesas/paginated"} />

                <AutocompletePaginado label={"Categoria"}
                    parameters={{
                        width: '25%',
                        label: "Categoria",
                        disabled: false,
                        bodyToSearch: { somenteAtivos: true, categoria: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => setCategoria(itemSelecionado?.item)
                    }}
                    endpoint={"configdespesas/paginated"} />
            </div>
            </CollapsibleFilters>

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} loading={loading} errorOccurred={fetchListError}/>
        </div>
    );
}

export default Despesas;
